<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="108"
        height="20"
        viewBox="0 0 108 20"
        fill="none"
    >
        <path
            d="M9.96859 19.8202C15.4741 19.8202 19.9371 15.3833 19.9371 9.9101C19.9371 4.43691 15.4741 0 9.96859 0C4.46309 0 0 4.43691 0 9.9101C0 15.3833 4.46309 19.8202 9.96859 19.8202Z"
            fill="white"
        />
        <path
            d="M6.26949 19.1032C6.14586 17.978 6.23361 16.9005 6.48088 15.8586L7.47794 11.5879C7.31443 11.0689 7.19079 10.4746 7.19079 9.88039C7.19079 8.49379 7.8648 7.50339 8.92169 7.50339C9.6555 7.50339 10.1939 8.01048 10.1939 8.989C10.1939 9.29803 10.1301 9.64665 10.0065 10.0428L9.57177 11.465C9.48402 11.7384 9.44814 11.996 9.44814 12.2217C9.44814 13.2121 10.2099 13.7707 11.179 13.7707C12.9099 13.7707 14.1462 11.988 14.1462 9.67438C14.1462 7.0993 12.4513 5.45125 9.94666 5.45125C7.15489 5.45125 5.38411 7.25776 5.38411 9.77342C5.38411 10.7876 5.6952 11.7305 6.30541 12.3722C6.10599 12.7051 5.89461 12.7684 5.57157 12.7684C4.57451 12.7684 3.6253 11.37 3.6253 9.46442C3.6253 6.17229 6.28146 3.54569 10.0065 3.54569C13.919 3.54569 16.3757 6.25548 16.3757 9.59912C16.3757 12.9665 13.9827 15.4941 11.4023 15.4941C10.3814 15.4941 9.48402 15.0623 8.85787 14.2818L8.34738 16.3379C8.0722 17.4036 7.66139 18.4059 6.99935 19.3725C7.93261 19.6578 8.85787 19.8202 9.9666 19.8202C15.4743 19.8202 19.9371 15.3871 19.9371 9.91605C19.9371 4.44498 15.4784 0 9.97059 0C4.46284 0 0 4.43311 0 9.90416C0 14.0521 2.56843 17.6294 6.26949 19.1032Z"
            fill="#E60023"
        />
        <mask
            id="mask0_17338_1459"
            style="mask-type: luminance"
            maskUnits="userSpaceOnUse"
            x="23"
            y="0"
            width="85"
            height="20"
        >
            <path d="M107.914 0H23.4302V19.8202H107.914V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_17338_1459)">
            <path
                d="M23.4414 2.04346H30.3736C33.3096 2.04346 35.6091 4.1409 35.6091 7.27041C35.6091 10.3777 33.3654 12.4974 30.3736 12.4974H27.0246V17.7909H23.4302V2.04346H23.4414ZM29.6815 9.30126C31.0769 9.30126 31.9252 8.6354 31.9252 7.27041C31.9252 5.90539 31.0769 5.23955 29.6815 5.23955H27.0359V9.30126H29.6815Z"
                fill="#E60023"
            />
            <path
                d="M36.119 6.50391H39.602V17.779H36.119V6.50391Z"
                fill="#E60023"
            />
            <path
                d="M40.3858 6.50506H43.6231V7.98105H43.7348C44.3376 6.90457 45.5542 6.19434 47.24 6.19434C49.7964 6.19434 51.5489 7.69249 51.5489 10.3892V17.7802H48.0661V11.6876C48.0661 10.3004 47.4857 9.45702 46.0901 9.45702C44.6501 9.45702 43.8689 10.2782 43.8689 12.1316V17.7802H40.3858V6.50506Z"
                fill="#E60023"
            />
            <path
                d="M53.2616 14.1173V9.2788H51.6207V6.50442H53.2616V3.65234H56.7445V6.50442H59.2339V9.2677H56.7445V13.3183C56.7445 14.5279 57.1463 14.994 58.2516 14.994C58.6087 14.994 58.9437 14.9275 59.2339 14.8386V17.7573C58.6979 17.957 57.9725 18.0903 57.1463 18.0903C54.4896 18.0903 53.2616 16.6143 53.2616 14.1173Z"
                fill="#E60023"
            />
            <path
                d="M101.849 14.1173V9.2788H100.208V6.50442H101.849V3.65234H105.332V6.50442H107.821V9.2677H105.332V13.3183C105.332 14.5279 105.733 14.994 106.839 14.994C107.196 14.994 107.531 14.9275 107.821 14.8386V17.7573C107.285 17.957 106.559 18.0903 105.733 18.0903C103.077 18.0903 101.849 16.6143 101.849 14.1173Z"
                fill="#E60023"
            />
            <path
                d="M59.0705 12.0871C59.0705 8.33615 61.6716 6.19434 64.9089 6.19434C68.4811 6.19434 70.6802 8.49152 70.6802 11.6655C70.6802 12.1316 70.6577 12.6642 70.5239 13.1635H62.5536C62.6652 14.4398 63.681 15.2388 65.0651 15.2388C66.2596 15.2388 66.9517 14.7283 67.3537 13.8739L70.3565 15.1057C69.776 16.8924 67.8895 18.0908 65.0988 18.0908C61.6716 18.0908 59.0705 16.0157 59.0705 12.0871ZM67.2642 10.8886C67.1525 9.54578 66.2038 8.81336 64.8867 8.81336C63.5806 8.81336 62.5982 9.52361 62.5311 10.8886H67.2642Z"
                fill="#E60023"
            />
            <path
                d="M71.1226 6.50506H74.3599V8.20299H74.4716C74.7616 6.97117 75.6436 6.19434 77.1618 6.19434C77.4522 6.19434 77.6976 6.19434 78.0547 6.28311V9.72335C77.8093 9.65677 77.5189 9.63457 77.184 9.63457C75.454 9.63457 74.6054 10.589 74.6054 12.6198V17.7802H71.1226V6.50506Z"
                fill="#E60023"
            />
            <path
                d="M77.8412 12.0871C77.8412 8.33615 80.4423 6.19434 83.6796 6.19434C87.2517 6.19434 89.4509 8.49152 89.4509 11.6655C89.4509 12.1316 89.4284 12.6642 89.2945 13.1635H81.3241C81.4358 14.4398 82.4516 15.2388 83.8358 15.2388C85.0302 15.2388 85.7224 14.7283 86.1243 13.8739L89.1271 15.1057C88.5466 16.8924 86.6601 18.0908 83.8692 18.0908C80.4422 18.0908 77.8412 16.0157 77.8412 12.0871ZM86.0349 10.8886C85.9232 9.54578 84.9745 8.81336 83.6571 8.81336C82.3512 8.81336 81.3687 9.52361 81.3018 10.8886H86.0349Z"
                fill="#E60023"
            />
            <path
                d="M89.2395 14.4509L92.5885 14.007C92.901 14.917 93.6934 15.4829 94.9438 15.4829C96.0041 15.4829 96.6295 15.1057 96.6295 14.4287C96.6295 13.9182 96.3167 13.6741 95.502 13.5853L93.3697 13.3411C90.7465 13.0304 89.8199 11.843 89.8199 9.85651C89.8199 7.67032 91.952 6.19434 94.6871 6.19434C97.6007 6.19434 99.5093 7.35959 100.012 9.32385L96.7521 9.98971C96.4395 9.25725 95.6916 8.78006 94.6423 8.78006C93.6155 8.78006 93.0906 9.13518 93.0906 9.69005C93.0906 10.1118 93.3585 10.3781 94.1959 10.4891L96.4842 10.7776C98.9066 11.0884 99.9001 12.2314 99.9001 14.0847C99.9001 16.6039 97.835 18.0798 94.8544 18.0798C91.8181 18.0908 89.7082 16.7259 89.2395 14.4509Z"
                fill="#E60023"
            />
            <path
                d="M39.9036 3.65293C39.9036 2.53206 38.9882 1.62207 37.8607 1.62207C36.7332 1.62207 35.8179 2.53206 35.8179 3.65293C35.8179 4.77378 36.7332 5.68377 37.8607 5.68377C38.9882 5.67267 39.9036 4.76268 39.9036 3.65293Z"
                fill="#E60023"
            />
        </g>
    </svg>
</template>

<script>
export default {
    name: 'Fox'
};
</script>
